import { render, staticRenderFns } from "./HeatmapVote.vue?vue&type=template&id=613d53cf&scoped=true"
import script from "./HeatmapVote.vue?vue&type=script&lang=ts"
export * from "./HeatmapVote.vue?vue&type=script&lang=ts"
import style0 from "./HeatmapVote.vue?vue&type=style&index=0&id=613d53cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613d53cf",
  null
  
)

export default component.exports